/**
 *  Filename ....: message-detail.component.ts
 *  Created by ..: ianday
 *  on Date .....: 1/10/24
 **/
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MessageDefinitionService} from "../../../../services/messages.service";
import {Settings} from "../../../../services/settings";
import {mergeTokens} from "codelyzer/angular/styles/cssAst";
import {MatTableDataSource} from "@angular/material/table";
import {MessageDefinition} from "../../../../models/message-definition";
import {DwUtils} from "../../../../components/utils/dw-utils";

@Component({
    selector: 'app-message-detail',
    templateUrl: './message-detail.component.html',
    styleUrls: ['./message-detail.component.css']
})

export class MessageDetailComponent implements OnInit {

    public _messageBody: string = '';
    public tokenList: any;
    public strErr: string = '';

    public displayedColumns: any = ['token', 'description'];
    public dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
    public Idx: number = -1;

    public selectedRecord: any;
    public cursorPos: number = 0;
    public copyVisible: boolean = false;

    @Input() set messageBody(val: string ) {
        this._messageBody = val;
    }

    get messageBody(): string {
        return this._messageBody;
    }

    @Output() cancelClicked = new EventEmitter();
    @Output() submitClicked = new EventEmitter<any>();

    constructor(public messageService:MessageDefinitionService) {

    }
    ngOnInit() {
        /** get a list of the tokens ... */
        this.queryTokenValues();

    }
    public applyFilter(filterValue:any): void {
        this.dataSource.filter = filterValue.trim().toLowerCase();
        this.unSelectRow();
    }
    public onRowClicked(selected: any) {

        this.selectedRecord = selected;
        this.selectRow();
    }
    public selectAndCopy(): void {
        this.copyVisible = true;
        this.copyToClipboard(this.selectedRecord.token);

       setTimeout(() => {
             this.copyVisible = false;
       }, 1000);

    }
    public tableKeyDown(event: KeyboardEvent) {

        const len: number = this.dataSource.filteredData.length;
        if (event.key === 'ArrowDown') {
            if (this.Idx < (len - 1)) {
                this.selectedRecord = this.dataSource.filteredData[++this.Idx];

            }
        } else if (event.key === 'ArrowUp') {
            if (this.Idx > 0) {
                this.selectedRecord = this.dataSource.filteredData[--this.Idx];
            }
        }
    }
    public selectRow() {
        if (this.selectedRecord.id === 0) {
            this.unSelectRow();
            return;
        }
        this.Idx = this.dataSource.filteredData.findIndex(s => s.id === this.selectedRecord.id);
    }
    public unSelectRow() {

        this.Idx = -1;
        this.selectedRecord = new MessageDefinition();
    }
    public queryTokenValues(): void {
        this.messageService.getAllMessageTokens().subscribe (

            (result) => {
                 this.tokenList = result.sort((a, b) => a.token.localeCompare(b.token));
                this.dataSource = new MatTableDataSource(this.tokenList);
            },
            (error) => {
                Settings.getInstance().handleError(error, 'fetching message tokens');
            });

    }
    public submitRecord(): void {

        if ((this._messageBody === null) || (this._messageBody.length === 0)) {
            this.strErr = 'Error: The message body cannot be blank';
            DwUtils.setFocus('messageBodyDetail');
            return;
        }

        this.submitClicked.emit(this._messageBody);
    }
    public cancelSubmitRecord(): void {
        this.cancelClicked.emit();
    }

    public doCursorPositioning(event: any) : void {
        this.strErr = ''

    }
    public copyToClipboard(item) {
        document.addEventListener('copy', (e: ClipboardEvent) => {
            e.clipboardData.setData('text/plain', (item));
            e.preventDefault();
            document.removeEventListener('copy', null);
        });
        document.execCommand('copy');
    }
}


